import React from "react";
import ContactInfo from "../../../components/ContactInfo";
import { Space, Card, Divider, Typography } from "antd";
import { useSelector } from "react-redux";
import { constants } from "../../../constants/common";
const { Title, Text } = Typography;

const ReportingCards = () => {
    const { user } = useSelector((state: any) => state.app);

    return <Space direction='vertical'>
        {(user?.reportingHR || user?.reportingBDE) && <Card className='contact_info'>
            <Space direction='vertical' >
                <div>
                    <Title className='noLine' level={5}>We're here to assist you</Title>
                    <Text type="secondary">
                        We're here to support and assist you every step of the way.
                    </Text>
                </div>
                {user?.reportingBDE && <ContactInfo
                    avatarUrl={`${process.env.FILE_URL}${user?.reportingBDE?.avatar}`}
                    email={user?.reportingBDE?.workEmail}
                    name={(user && user?.reportingBDE) ? constants.GET_FULL_NAME(user?.reportingBDE) : ''}
                    phone={user?.reportingBDE?.mobile}
                    role={user?.reportingBDE?.jobTitles?.name}
                />}
                <Divider />
                {user?.reportingHR && <ContactInfo
                    avatarUrl={`${process.env.FILE_URL}${user?.reportingHR?.avatar}`}
                    email={user?.reportingHR?.workEmail}
                    name={(user && user?.reportingHR) ? constants.GET_FULL_NAME(user?.reportingHR) : ''}
                    phone={user?.reportingHR?.mobile}
                    role={user?.reportingHR?.jobTitles?.name}
                />}
            </Space>
        </Card>}
        {user?.reportingManager && <Card className='contact_info'>
            <Space direction='vertical'>
                <div>
                    <Title level={5} className='noLine'>My Team</Title>
                    <Text type="secondary">
                        Reporting Manager
                    </Text>
                </div>
                <ContactInfo
                    avatarUrl={`${process.env.FILE_URL}${user?.reportingManager?.avatar}`}
                    email={user?.reportingManager?.workEmail}
                    name={(user && user?.reportingManager) ? constants.GET_FULL_NAME(user?.reportingManager) : ''}
                    phone={user?.reportingManager?.mobile}
                    role={user?.reportingManager?.jobTitles?.name}
                />
            </Space>
        </Card>}
    </Space>
}

export default ReportingCards;